function initializeGetOfferForm() {
  const getOfferForm = document.getElementById("getOfferForm");
  if (!getOfferForm) {
    return;
  }

  // --- DEBUGGING: Confirm the script is running for the correct form ---
  console.log("Get Offer Form JS Handler: Initialized.");

  const formWrapper = getOfferForm.closest(".contact-us-form");
  let formMessagesDiv = formWrapper
    ? formWrapper.querySelector(".form-messages-container")
    : null;
  if (!formMessagesDiv && formWrapper) {
    formMessagesDiv = document.createElement("div");
    formMessagesDiv.className = "form-messages-container mb-4";
    formWrapper.insertBefore(formMessagesDiv, getOfferForm);
  }

  // Find the server-debug-output div we added in the PHP partial
  const serverDebugOutput = document.getElementById("server-debug-output");

  getOfferForm.addEventListener("submit", function (event) {
    event.preventDefault();

    // --- DEBUGGING: Log form submission event ---
    console.log("Get Offer Form: Submit event triggered.");

    if (formMessagesDiv) formMessagesDiv.innerHTML = "";
    if (serverDebugOutput) serverDebugOutput.style.display = "none"; // Hide previous debug info

    const formData = new FormData(getOfferForm);

    // --- DEBUGGING: Log form data before sending ---
    console.log(
      "Get Offer Form: Form data collected. Sending AJAX request to:",
      window.themeVariables?.ajaxUrl
    );
    // Log FormData entries for inspection
    for (let [key, value] of formData.entries()) {
      console.log(`- ${key}:`, value);
    }

    const submitButton = getOfferForm.querySelector('button[type="submit"]');
    const originalButtonText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = "Gönderiliyor...";

    fetch(window.themeVariables?.ajaxUrl || "/wp-admin/admin-ajax.php", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        // --- DEBUGGING: Log raw response from server ---
        console.log("Get Offer Form: Received raw server response:", response);
        if (!response.ok) {
          // This catches HTTP errors like 500, 404 etc.
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // --- DEBUGGING: Log the parsed JSON data ---
        console.log("Get Offer Form: Parsed JSON response:", data);

        if (data.success) {
          const successMsg =
            window.themeVariables?.getOfferFormSuccessMsg ||
            data.data?.message ||
            "Talebiniz başarıyla alındı.";
          formMessagesDiv.innerHTML = `<div class="alert alert-success">${successMsg}</div>`;
          getOfferForm.reset();
        } else {
          // This handles errors sent back from WordPress (wp_send_json_error)
          const errorMsg =
            data.data?.message ||
            window.themeVariables?.getOfferFormErrorMsg ||
            "Bilinmeyen bir hata oluştu.";
          formMessagesDiv.innerHTML = `<div class="alert alert-danger">${errorMsg}</div>`;

          // --- DEBUGGING: Display server-side debug info if it exists ---
          if (data.data && data.data.debug_info && serverDebugOutput) {
            console.error("Server-side debug info:", data.data.debug_info);
            serverDebugOutput.style.display = "block";
            serverDebugOutput.innerHTML = `<pre>${data.data.debug_info}</pre>`;
          }
        }
      })
      .catch((error) => {
        // This catches network errors or the HTTP error thrown above
        console.error("Get Offer Form: Fetch request failed.", error);

        const errorMessage =
          window.themeVariables?.getOfferFormErrorMsg ||
          "Bir ağ hatası oluştu. Lütfen daha sonra tekrar deneyin.";
        formMessagesDiv.innerHTML = `<div class="alert alert-danger">${errorMessage}</div>`;

        // --- DEBUGGING: Display the error message in the debug output area ---
        if (serverDebugOutput) {
          serverDebugOutput.style.display = "block";
          serverDebugOutput.innerHTML = `<pre>İstemci Tarafı Hata:\n${error.message}</pre>`;
        }
      })
      .finally(() => {
        // --- DEBUGGING: Log that the fetch process has completed ---
        console.log("Get Offer Form: Fetch process finished.");

        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      });
  });
}

// Ensure the script runs after the DOM is loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeGetOfferForm);
} else {
  initializeGetOfferForm();
}
